import { SERVICE, type ServiceType } from '@musinsa/packages-device-detection';

/**
 * 서비스(service)에 해당하는 큐레이터 API base URL을 반환합니다.
 * Musinsa/29CM 구분은 @musinsa/packages-device-detection의 ServiceType 기준이며,
 * UNKNOWN 또는 env 미설정 시 29CM URL로 fallback합니다.
 */
export const getCuratorApiBaseURL = (service: ServiceType): string => {
  const url29 = process.env.NEXT_PUBLIC_CURATOR_API_BASE_URL_29CM;
  const urlMusinsa = process.env.NEXT_PUBLIC_CURATOR_API_BASE_URL_MUSINSA;

  if (service === SERVICE.MUSINSA && urlMusinsa) {
    return urlMusinsa;
  } else {
    return url29 ?? '';
  }
};
